import React, { memo } from 'react';

/**
 * CategoryTags - Displays tags for a todo item (category/primary tag removed)
 */
const CategoryTags = memo(({
  task,
  allTags = [],
  elementVisibility = {},
}) => {
  // Only show tags when enabled and task has tags
  if (elementVisibility.tags === false || !task.tags || task.tags.length === 0) {
    return null;
  }

  return (
    <span className="todo-item__tags" title={`Tags: ${task.tags.join(', ')}`}>
      {task.tags.slice(0, 2).map((tag, i) => {
        const tagInfo = allTags.find(t => t.name === tag);
        return (
          <span 
            key={i} 
            className="todo-item__tag"
            style={{ '--tag-color': tagInfo?.color || '#6b7280' }}
          >
            {tag}
          </span>
        );
      })}
      {task.tags.length > 2 && (
        <span className="todo-item__tag todo-item__tag--more">+{task.tags.length - 2}</span>
      )}
    </span>
  );
});

CategoryTags.displayName = 'CategoryTags';

export default CategoryTags;
